import script from "./Select.vue?vue&type=script&setup=true&lang=ts"
export * from "./Select.vue?vue&type=script&setup=true&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=7efaf0bf&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efaf0bf"]])

export default __exports__